export const initialState = {
    data: null,
    loading:false,
    error: null,
    errorMessage: null,
    isChooseMaterialtypeModelOpen:false
  };